// Import our CSS
import "@/scss/app.scss";


import './components/scroll-detection.js';
import "./components/mega-menu.js";
import "./components/branch-links.js";
import "./components/popups.js";
import "./components/browser-resize.js";
import "./components/typing-text.js";
import "./components/freeform-csrf.js";
import "./components/header-offset.js";
import "./components/urgent-message.js";
import "./components/geo-redirect.js";

import "./3rd-party/open-iframe-resizer.js";
import "./3rd-party/freeform.js";


/* import AOS from "aos";
// animation
AOS.init(); */


// Lazy-load map navigator only on pages that need it
document.addEventListener('DOMContentLoaded', () =>
{
	const mapContainers = document.querySelectorAll('.jsMap');
	if (mapContainers.length === 0) return;

	mapContainers.forEach(container =>
	{
		import('@js/components/map-navigator.js')
			.then(module =>
			{
				new module.default(`#${container.id}`);
			})
			.catch(err =>
			{
				console.error('Failed to load MapNavigator:', err);
			});
	});
});